export const saveToken = (token) => window.localStorage.setItem('bearer-token', token);

export const getToken = () => window.localStorage.getItem('bearer-token');

export const deleteToken = () => {
  try {
    window.localStorage.removeItem('bearer-token');
  } catch (e) {
    console.log('error');
  }
};
